import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const CardFilledIcon: FC<SvgProps> = ({ fill, ...props }) => {
    const color = fill || 'currentColor'

    return (
        <Svg viewBox="0 0 20 20" width={20} height={20} fill="none" {...props}>
            <Path
                fill={color}
                d="M18.002 6.894V6.16c0-.777-.638-1.408-1.408-1.408H3.408A1.406 1.406 0 0 0 2 6.151v.736h16.002zM2 8.183v5.658c0 .777.637 1.408 1.408 1.408h13.179c.777 0 1.408-.638 1.408-1.408V8.183zm13.754 4.468a.454.454 0 0 1-.455.455h-1.415a.454.454 0 0 1-.455-.455v-1.415c0-.252.203-.455.455-.455h1.415c.252 0 .455.203.455.455z"
            />
        </Svg>
    )
}

export default CardFilledIcon
